import ChangePasswordForm from "./Form"

function ChangePassword() {
    return (
       <ChangePasswordForm></ChangePasswordForm>
    )
}

export default ChangePassword
